module.exports = __webpack_public_path__ + "static/media/organisation-d-ateliers-citoyen-sur-des-grands-sujets-de-societe-mini.3d1f50e4.jpg";